export const DealsRoutes = {
  // Travel Deals
  TRAVEL_DEALS_LIST: "/travel-deals",
  TRAVEL_DEALS_CREATE: "/travel-deals/new",
  TRAVEL_DEALS_EDIT: "/travel-deals/:id",
  // Combo Offers
  COMBO_OFFERS_LIST: "/combo-offers",
  COMBO_OFFERS_CREATE: "/combo-offers/new",
  COMBO_OFFERS_EDIT: "/combo-offers/:id",
} as const;
